<template>
	<!-- v-on="$listeners" permet de diffuser les évènements d'ObjectMenuItem aux composants parents d'ObjectMenuMenuItem 
	(en particulier CloseObjectMenuEvent pour fermeture du menu) -->
	<object-menu-item :MenuItems="localMenu" :ObjectType="ObjectType" :Constraints="Constraints" :ParentNode="ParentNode" v-on="$listeners" />
</template>

<script lang="ts">
	import { Component, Prop, PropSync, Vue, Watch } from "vue-property-decorator";
	import ObjectMenuItem from "./ObjectMenu/ObjectMenuItem.vue";
	import Dictionary from "@/types/Dictionary";
	import MenuItem from "@/types/MenuItem";
	import locales from "./locales/ObjectMenu.json";
	import TreeNode from "@/types/TreeNode";
	
	/** Composant de menu de création d'objet */
	@Component({
		name: 'object-menu',
		components: {
			ObjectMenuItem
		},
		i18n: { messages: locales }
	})
	export default class ObjectMenu extends Vue {
		@Prop()
		public ObjectType!: string;

		@Prop()
		public Menu!: MenuItem[];
		private localMenu: MenuItem[] = [];

		@Prop()
		public Constraints!: Dictionary<any>;

		/** NodeId parent du nouveau noeud à créer */
		@Prop()
		public ParentNode!: TreeNode;

		/** Indique si des items de menus de premier niveau existent ou non */
		@PropSync('IsFirstLevelMenus', { default: () => false})
		private isFirstLevelMenus!: boolean

		/** Affiche ou masque les MenuItems en fonction du noeud sélectionné et des contraintes associées à son ObjectType */
		@Watch('Menu', {immediate: true})
		@Watch('Constraints', {immediate: true})
		@Watch('ObjectType', {immediate: true})
		private updateConstraintMenu() {
			console.debug("ObjectMenu - updateConstraintMenu() - this.Menu.length : ", this.ObjectType);

			let constraints: string[] = this.Constraints[this.ObjectType];
			
			console.debug("ObjectMenu - updateConstraintMenu() - constraints : ", constraints);

			this.localMenu = JSON.parse(JSON.stringify(this.Menu));

			this.localMenu.forEach(menuItem => {
				if (constraints && menuItem.SubItems)
					menuItem.Visible = this.displayMenuItem(menuItem.SubItems, constraints);
			});

			// Vérifie si au moins un des menu de premier niveau est visible
			this.isFirstLevelMenus = (this.localMenu.filter(menuItem => menuItem.Visible === true).length > 0);
		}

		/** Affiche ou masque un ensemble d'item de menu si le ObjectType existe dans constraints   */
		/** @return Renvoi True uniquement si au moins un des enfants est visible */
		private displayMenuItem(menuItems: MenuItem[], constraints: string[]) {
			let result = false;
			menuItems.forEach(menuItem => {
				let index = constraints.findIndex(constraint => constraint == menuItem.ObjectType);
				menuItem.Visible = (index > -1);

				// Pour afficher/masquer le parent si au moins un des enfants est visible
				if (menuItem.Visible)
					result = true;
				
				// Boucle sur les enfants du menu
				this.displayMenuItem(menuItem.SubItems, constraints);
			});

			return result;
		}
	}
</script>

<style scoped>
</style>